export default {
    home: 'Inicio',
    auth: 'Bienvenido',
}
